import type { ChangeEvent, Dispatch, SetStateAction } from 'react'
import type { ControllerRenderProps } from 'react-hook-form'
import type { BranchForForm } from 'types'

import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Loader, TextInput } from 'components'
import { trimFirstSpace, validateKeyPress } from 'helpers/common'

interface IInputPostalCode {
  isPostalCodeChecking: boolean
  setIsPostalCodeChecking: Dispatch<SetStateAction<boolean>>
  field: ControllerRenderProps
}

export const InputPostalCode: React.FC<IInputPostalCode> = ({
  isPostalCodeChecking,
  setIsPostalCodeChecking,
  field,
}) => {
  const { errors, watch, trigger } = useFormContext<BranchForForm>()

  const { isSameAsCompany } = watch(['isSameAsCompany'])
  const { t } = useTranslation(['common'])

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    field.onChange(trimFirstSpace(e))
  }

  const onBlur = async () => {
    setIsPostalCodeChecking(true)
    await trigger('postalCode')
    setIsPostalCodeChecking(false)
  }

  const isError = field.value ? false : Boolean(errors.postalCode?.message)
  const errorMsg = !field.value ? errors.postalCode?.message : ''

  return (
    <TextInput
      value={field.value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={t('common:address.postalCode.placeholder')}
      isError={isError}
      message={errorMsg}
      maxLength={8}
      onKeyPress={validateKeyPress(new RegExp(/[\p{L}\p{N}\-]/u))}
      withIcon={isPostalCodeChecking && <Loader />}
      disabled={isSameAsCompany}
      ref={field.ref}
    />
  )
}
